<template>
  <div>
    <div v-if="showCorporateMessage">
      <p>Corporate exclusive.</p>
    </div>
    <div v-if="showB2BMessage">
      <p>Not available for corporate orders.</p>
    </div>
  </div>
</template>

<script>

import { mapGetters } from "vuex";

export default {
  props: {
    product: Object
  },
  computed: {
    ...mapGetters(['isB2B', 'currentMarket']),
    showCorporateMessage() {
      return (!this.b2cCanBuy && this.b2bCanBuy) && !this.isB2B;
    },
    showB2BMessage() {
      return this.isB2B && this.b2cCanBuy && !this.b2bCanBuy;
    },
    b2cCanBuy() {
      return this.product.shopify_metafields.allowed_for_b2c;
    },
    b2bCanBuy() {
      return this.product.shopify_metafields.allowed_for_b2b;
    },
  }
};
</script>
